import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IAppTypesApiResponse } from 'src/app/shared/models/app.interface';
import { CommonService } from '../../../app/shared/services/common.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppsService extends CommonService {
  idSecurityFinding: string;
  updateTableInfo = new Subject<any>();
  updateTableInfo$: Observable<any> = this.updateTableInfo.asObservable();
  readonly baseUrl = environment.urls.apiBaseUrl;
  updateAppData(uuid, body) {
    return this.httpClient.patch(this.baseUrl + 'apps/' + uuid, body);
  }

  public getApp(uuid) {
    return this.get('apps/' + uuid);
  }

  public getSecurityFindingsDetail(appUuid, findingId) {
    return this.httpClient.get<any>(
      this.baseUrl + `apps/${appUuid}/issues/${findingId}?status=open`,
    );
  }

  public getSecurityFindings(appUuid: string) {
    return this.httpClient.get<any>(
      this.baseUrl + `apps/${appUuid}/issues?status=open`,
    );
  }

  public refreshSecurityFindings(appUuid) {
    return this.httpClient.post<any>(
      this.baseUrl + `apps/${appUuid}/security_findings/refresh`,
      '',
    );
  }

  public closeAllTargets(app, finding, body) {
    return this.httpClient.post<any>(
      this.baseUrl + `apps/${app}/issues/${finding}/close`,
      body,
    );
  }

  public updateFinding(app, finding, body) {
    return this.httpClient.patch<any>(
      this.baseUrl + `apps/${app}/issues/${finding}`,
      body,
    );
  }

  public closeOneTarget(app, finding, target, body) {
    return this.httpClient.post<any>(
      this.baseUrl + `apps/${app}/issues/${finding}/targets/${target}/close`,
      body,
    );
  }

  getAppTypes() {
    return this.httpClient.get<IAppTypesApiResponse>(
      this.baseUrl + 'apps/types',
      { withCredentials: true },
    );
  }
  public UpdateAppTool(app, toolName, body) {
    return this.httpClient.put<any>(
      this.baseUrl + `apps/${app}/tools/${toolName}/config`,
      body,
    );
  }

  public getFunctionalChecks(appGuid: string) {
    return this.httpClient.get<any>(
      this.baseUrl + `apps/${appGuid}/functional_checks`,
      { withCredentials: true },
    );
  }

  public getEvidenceHistory(appGuid: string, functionalCheckHash: string) {
    return this.httpClient.get<any>(
      this.baseUrl +
        `apps/${appGuid}/functional_checks/${functionalCheckHash}/evidences`,
      { withCredentials: true },
    );
  }

  public reviewEvidence(appGuid: string, functionalCheckHash: string, body) {
    return this.httpClient.post<any>(
      this.baseUrl +
        `apps/${appGuid}/functional_checks/${functionalCheckHash}/evidences/review`,
      body,
    );
  }
  public getAppUsers(appGuid: string) {
    return this.httpClient.get<any>(this.baseUrl + `users`, {
      withCredentials: true,
      params: { app_id: appGuid },
    });
  }
  public deleteUser(userUuid: string) {
    return this.httpClient.delete<any>(this.baseUrl + `users/${userUuid}`, {
      withCredentials: true,
    });
  }
  public getAppGroups(appGuid: string) {
    return this.httpClient.get<any>(this.baseUrl + `apps/${appGuid}/groups`, {
      withCredentials: true,
    });
  }
  public addOrEditUser(userName: string, body) {
    return this.httpClient.put<any>(this.baseUrl + `users/${userName}`, body);
  }
  public getUser(userName: string) {
    return this.httpClient.get<any>(this.baseUrl + `users/${userName}`, {
      withCredentials: true,
    });
  }
}
